import { Navigate } from 'react-router-dom'
import { useAuth } from '@shared/auth/authContext'
import { ROLE_HOME_ROUTES } from '@shared/auth/roleGuard'
import { type UserRole } from '@shared/config/constants'
import { ROUTES } from '@shared/config/routes'

interface Props {
  role: UserRole
  children: React.ReactNode
}

/** Ensures the authenticated user has the required role.
 *  Wrong role → redirect to their correct home route.
 */
export function RoleRoute({ role: requiredRole, children }: Props) {
  const { isAuthenticated, role, isLoading } = useAuth()

  if (isLoading) return null

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />
  }

  if (role && role !== requiredRole) {
    return <Navigate to={ROLE_HOME_ROUTES[role] ?? ROUTES.LOGIN} replace />
  }

  return <>{children}</>
}
